import { render, staticRenderFns } from "./AdminMessagesForm.vue?vue&type=template&id=12ee4ce8&scoped=true"
import script from "./AdminMessagesForm.vue?vue&type=script&lang=js"
export * from "./AdminMessagesForm.vue?vue&type=script&lang=js"
import style0 from "./AdminMessagesForm.vue?vue&type=style&index=0&id=12ee4ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ee4ce8",
  null
  
)

export default component.exports